import React from 'react';
import { Icon, Placeholder } from './styled';

export default () =>
  <Placeholder>
    <Icon icon='user' width='100px' />
  </Placeholder>;
